(()=>{
  const images={
    "the-armored-kingdom-100-grass-fed-carne-asada-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-01.png?v=1793398132",
    "the-armored-kingdom-gourmet-applewood-smoke-style-bacon-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-02.png?v=1793398131",
    "the-armored-kingdom-gourmet-armageddon-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-03.png?v=1793398132",
    "the-armored-kingdom-gourmet-carolina-reaper-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-04.png?v=1793398132",
    "the-armored-kingdom-gourmet-cracked-black-pepper-beef-jerky-3oz-savory-high-protein-snack-resealable-bag-u-s-a-inspected-approved-dried":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-05.png?v=1793398132",
    "the-armored-kingdom-gourmet-garlic-pepper-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-06.png?v=1793398132",
    "the-armored-kingdom-gourmet-honey-pepper-bacon-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-07.png?v=1793398132",
    "the-armored-kingdom-gourmet-korean-bbq-recipe-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-08.png?v=1793398132",
    "the-armored-kingdom-gourmet-lemon-pepper-beef-jerky-3oz-high-protein-dried-snack":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-09.png?v=1793398132",
    "the-armored-kingdom-gourmet-mango-habanero-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-10.png?v=1793398132",
    "the-armored-kingdom-gourmet-original-style-jerky-traditional-savory-usa-made-high-protein-dried-snack-3oz-resealable-sharing-size-bag":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-11.png?v=1793398132",
    "the-armored-kingdom-gourmet-serrano-pineapple-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-12.png?v=1793398132",
    "the-armored-kingdom-gourmet-spicy-sweet-jerky-dried-snack-dry-meat-protein-snack-savory":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-13.png?v=1793398132",
    "the-armored-kingdom-gourmet-straight-whiskey-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-14.png?v=1793398131",
    "the-armored-kingdom-gourmet-tropical-fusion-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-15.png?v=1793398132",
    "the-armored-kingdom-gourmet-western-bbq-recipe-bacon-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-16.png?v=1793398132",
    "the-armored-kingdom-peppered-orange-teriyaki-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-17.png?v=1793398132",
    "the-armored-kingdom-sea-salt-honey-amp-pepper-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-18.png?v=1793398131",
    "the-armored-kingdom-teriyaki-beef-jerky":"https://cdn.shopify.com/s/files/1/0753/8979/6508/files/ak-transparent-jerky-19.png?v=1793398132"
  };

  const selectors=[
    '.ak-hero-product img',
    '.ak-inventory-card__media img',
    '.ak-card-media img',
    '.ak-front-product img',
    '.ak-switcher-media img',
    '.ak-collection-card__media img'
  ].join(',');

  const handleFromLink=(link)=>{
    if(!link)return'';
    try{
      const path=new URL(link.href,location.origin).pathname;
      const m=path.match(/\/products\/([^/?#]+)/);
      return m?decodeURIComponent(m[1]):'';
    }catch{return''}
  };

  const apply=(img)=>{
    if(!(img instanceof HTMLImageElement))return;
    const link=img.closest('a[href*="/products/"]');
    const handle=handleFromLink(link);
    const src=images[handle];
    if(!src)return;
    if(img.dataset.akTransparentSrc===src)return;
    img.dataset.akTransparentSrc=src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src=src;
  };

  const scan=(scope=document)=>{
    if(scope.matches?.(selectors))apply(scope);
    scope.querySelectorAll?.(selectors).forEach(apply);
  };

  const init=()=>{
    scan(document);
    const observer=new MutationObserver(records=>{
      records.forEach(record=>record.addedNodes.forEach(node=>{
        if(node.nodeType===1)scan(node);
      }));
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  window.addEventListener('pageshow',()=>scan(document));
})();